import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  const navigationLinks = [{
    path: '/',
    label: 'Home'
  }, {
    path: '/about',
    label: 'About Us'
  }, {
    path: '/programs',
    label: 'Programs'
  }, {
    path: '/team',
    label: 'Meet the Team'
  }, {
    path: '/training-center',
    label: 'Training Center'
  }, {
    path: '/roadmap',
    label: 'Roadmap'
  }, {
    path: '/support',
    label: 'Support'
  }, {
    path: '/contact',
    label: 'Contact Us'
  }];
  return <footer className="bg-white py-12 border-t border-gray-200" data-id="element-134" data-mp="3lf57aqtrlpme">
      <div className="max-w-7xl mx-auto px-4" data-id="element-135" data-mp="3qdf2v2jeis8j">
        <div className="flex flex-col items-center gap-8" data-id="element-136" data-mp="3qc40n75ltsjj">
          <Link to="/" className="transform transition-transform hover:-translate-y-1" data-id="element-137" data-mp="29zgjjx8osmkj">
            <img src="https://cdn.magicpatterns.com/uploads/gznFEFjybyktnP4QK9mR3y/new_ictf_logo_real_blue.png" alt="Israeli Civilian Training Foundation Logo" className="h-14" data-id="element-138" data-mp="2eyjoziskwut1" />
          </Link>
          <nav className="w-full max-w-xl" data-id="element-139" data-mp="3gcjw6rxsy2hf">
            <ul className="flex flex-wrap justify-center gap-y-4 gap-x-6" data-id="element-140" data-mp="3v7zwheoz6um9">
              {navigationLinks.map(link => <li key={link.path} data-id="element-141" data-mp="3q724ybi2so83">
                  <Link to={link.path} className="text-gray-600 hover:text-israel-blue transition-all transform hover:-translate-y-1 font-light tracking-normal" data-id="element-142" data-mp="830jvkr3s91j">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
          <div className="text-center" data-id="element-143" data-mp="cus1h5sa74fj">
            <p className="text-gray-600 font-light" data-id="element-144" data-mp="cvtlw0v6t39x">
              &copy; {new Date().getFullYear()} Israeli Civilian Training
              Foundation. All rights reserved. |{' '}
              <Link to="/privacy" className="hover:text-israel-blue" data-id="element-145" data-mp="mtrcgv0irc5p">
                Privacy
              </Link>{' '}
              |{' '}
              <Link to="/terms" className="hover:text-israel-blue" data-id="element-146" data-mp="ytxzdq8vqn32">
                Terms
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;